export default "/Frontend/dist/event-background2-grey.70d10ce309c2115285bf1e1c480ed353.svg";